import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';

// Validation schema for Location Info
export const bankingInfoSchema = Yup.object({
    account: Yup.boolean(),

    PaymentMethod: Yup.string()
        .required(CommonMessages.paymentType_required)
        .notOneOf(['0'], CommonMessages.paymentType_required),

        stripeSecretKey: Yup.string()
        .when('PaymentMethod', {
            is: '1',
            then: (schema) => schema.required(CommonMessages.stripeSecretKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),

    stripePublicKey: Yup.string()
        .when('PaymentMethod', {
            is: '1',
            then: (schema) => schema.required(CommonMessages.stripePublicKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),

})